// Authentication
import api from "../api";
import { ApiUtils } from "../utils/ApiUtils";

import router from "@/router"

export const setDeliveryZipcode = ({ commit }, zipcode) => {
  commit('SET_DELIVERY_ZIPCODE', zipcode);
}

export const authenticate = ({ commit }, data) => {
  commit('SET_AUTH_DATA', data);
};

export const signOut = async ({ commit }) => {
  commit('CLEAR_AUTH_DATA');
  try {
    await router.push('/auth/sign-in');
  } catch {
  }

};

export const setCurrentOrder = async ({ commit }, order) => {
  commit('SET_CURRENT_ORDER', order);
}

export const updateCurrentOrder = async ({ commit }, order) => {
  commit('UPDATE_CURRENT_ORDER', order);
}

export const getOrder = async ({ commit }, id = 1) => {
  const _order = await api.getOrder(id);
  commit('SET_CURRENT_ORDER', _order);
  commit('SET_ORDER_DETAILS_EDITED_STATUS', false);
};

export const getOrderByUuid = async ({ commit }, uuid = 1) => {
  const _order = await api.getOrderByUuid(uuid);
  commit('SET_CURRENT_ORDER', _order);
  commit('SET_ORDER_DETAILS_EDITED_STATUS', false);
};

export const createOrder = async (
  { commit, getters, dispatch },
  _order = ApiUtils.mapOrderDetailsToApi(getters.orderDetails)
) => {
  try {
    commit('SET_ORDER_DETAILS_ERRORS', {});
    const order = await api.createOrder(_order);
    commit('SET_CURRENT_ORDER', order);
    commit('SET_ORDER_DETAILS_EDITED_STATUS', false);
  } catch (e) {
    commit('SET_ORDER_DETAILS_ERRORS', ApiUtils.extractBackendErrors(e));
    commit('SET_ERROR_MESSAGE', 'Seems like you entered incorrect order details. Please, check errors');
    if (getters.currentStep !== 0) {
      dispatch('setCurrentStep', 0);
    }
    throw e;
  }
};

export const updateOrder = async (
  { commit, getters },
  _order = ApiUtils.mapOrderDetailsToApi(getters.orderDetails)
) => {
  try {
    commit('SET_ORDER_DETAILS_ERRORS', {});
    const order = await api.updateOrder(getters.currentOrderId, _order);
    commit('SET_CURRENT_ORDER', order);
    commit('SET_ORDER_DETAILS_EDITED_STATUS', false);
  } catch (e) {
    commit('SET_ERROR_MESSAGE', 'Seems like you entered incorrect order details. Please, check errors');
    commit('SET_ORDER_DETAILS_ERRORS', ApiUtils.extractBackendErrors(e));
    throw e;
  }
};

export const resolveApiError = ({ commit }, e) => {
  commit('SET_ERROR_MESSAGE', e);

  setTimeout(() => {
    commit('HIDE_ERROR_MESSAGE')
  }, 3000)
}

export const clearApiError = ({ commit }) => {
  commit('HIDE_ERROR_MESSAGE')
}

// Order menu
export const getMenu = async ({ commit }, id = 1) => {
  const menu = await api.getMenu(id);
  commit('SET_ORDER_MENU', menu);
  commit('SET_ORDER_SELECTED_MENU', menu.categories?.map(category => {
    const ct = { ...category };
    ct.items = ct.items.filter(item => item.isDefault)
    return ct;
  }))
}

export const setOrderSelectedMenu = ({ commit }, menu) => {
  commit('SET_ORDER_SELECTED_MENU', menu);
}

export const createOrderMenu = async (
  { commit, getters },
  menu = ApiUtils.mapOrderMenuToApi(getters.currentOrderId, getters.selectedMenu)
) => {
  try {
    commit('SET_ORDER_MENU_ERRORS', {})
    await api.createOrderMenu(getters.currentOrderId, menu);
    commit('MENU_CREATED', true);
    commit('SET_ORDER_MENU_EDITED_STATUS', false);
  } catch (e) {
    commit('SET_ERROR_MESSAGE', 'Seems like your menu is not full. Please, check errors');
    commit('SET_ORDER_MENU_ERRORS', ApiUtils.extractBackendErrors(e));
    throw e;
  }
};

export const setMenuCreated = ({ commit }) => {
  commit('MENU_CREATED', true);
}

export const updateOrderMenu = async (
  { commit, getters },
  menu = ApiUtils.mapOrderMenuToApi(getters.currentOrderId, getters.selectedMenu)
) => {
  try {
    commit('SET_ORDER_MENU_ERRORS', {})
    await api.updateOrderMenu(getters.currentOrderId, menu);
    commit('SET_ORDER_MENU_EDITED_STATUS', false)
  } catch (e) {
    commit('SET_ERROR_MESSAGE', 'Seems like your menu is not full. Please, check errors');
    commit('SET_ORDER_MENU_ERRORS', ApiUtils.extractBackendErrors(e));
    throw e;
  }
};

export const setMenuDefaultItem = ({ commit, getters }, { item, category }) => {
  if (getters.selectedMenu.find(ct => ct.id === category.id)?.items?.find(i => i.id === item.id)?.isDefault) {
    commit('SET_ITEM_NOT_DEFAULT', { item, category });
  } else {
    commit('SET_ITEM_DEFAULT', { item, category })
  }
}

export const selectMenuItem = ({ commit, getters }, { item, category }) => {
  const _item = getters.selectedMenu.find(ct => ct.id === category.id).items.find(it => it.id === item.id);
  if (!_item) {
    commit('SELECT_MENU_ITEM', { item, category })
  } else {
    commit('UNSELECT_MENU_ITEM', { item, category });
  }

  if (!getters.menuTouched) {
    commit('SET_ORDER_MENU_EDITED_STATUS', true);
  }
}

export const selectMenuItemAttendee = ({ commit, state }, data) => {
  const category = state.selectedMenu.find(c => c.id === data.category.id);

  if (category && category.items.map(i => i.id).includes(data.item.id)) {
    commit('UNSELECT_MENU_ITEM_ATTENDEE', data);
  } else {
    commit('SELECT_MENU_ITEM_ATTENDEE', data);
  }
}

// FINALIZE ORDER
export const finalizeOrder = async ({ commit, getters }) => {
  const order = await api.finalizeOrder(getters.currentOrderId);
  commit('UPDATE_CURRENT_ORDER', order);
}

export const finalizeOrderWithCoupon = async ({ commit, getters }, coupon) => {
  const order = await api.finalizeOrderWithCoupon(getters.currentOrderId, coupon);
  commit('UPDATE_CURRENT_ORDER', order);
}

// Order Categories
export const getCategories = async ({ commit, getters }, _order = getters.currentOrderId) => {
  const categories = await api.getCategories(_order);
  commit('SET_ORDER_CATEGORIES', categories);
}

export const addCategory = ({ commit }, category) => {
  commit('ADD_ORDER_CATEGORY', category);
}

export const updateCategory = ({ commit }, category) => {
  commit('EDIT_ORDER_CATEGORY', category);
}

export const save_categories = async (
  { commit, getters },
  data = {
    body: ApiUtils.mapOrderCategoriesToApi(getters.currentOrderId, getters.categories),
    categories: getters.categories
  },
  _order = _order = getters.currentOrderId
) => {
  const categories = await api.createOrderCategories(_order, data.body);
};

// Line Items
export const getLineItems = async ({ commit, getters }, _order = getters.currentOrderId) => {
  const lineItems = await api.getLineItems(_order);
  commit('SET_ORDER_LINE_ITEMS', lineItems);
}

export const addLineItem = ({ commit }, lineItem) => {
  commit('ADD_ORDER_LINE_ITEM', lineItem);
}

export const updateLineItem = ({ commit }, props) => {
  commit('EDIT_ORDER_LINE_ITEM', { lineItem: props.lineItem, indexCategory: props.categorySelected });
}

export const save_line_items = async (
  { commit, getters },
  data = {
    body: ApiUtils.mapOrderLineItemsToApi(getters.currentOrderId, getters.lineItems),
    lineItems: getters.lineItems
  },
  _order = getters.currentOrderId
) => {
  const lineItems = await api.createLineItems(_order, data.body);
};

export const save_categories_names = async (
  { commit, getters },
  data = {
    body: ApiUtils.mapNameCategoriesToApi(getters.currentOrderId, getters.categories),
    categories: getters.categories
  },
  _order = _order = getters.currentOrderId
) => {
  const categories = await api.createOrderCategories(_order, data.body);
}

// Invite Order
export const Invite_to_order = async (
  { commit, getters },
  data
) => {
  const invite = await api.inviteToOrder(data.orderId, data.body)
  return invite
}


// Order Messages
export const loadOrderMessages = async (context, id) => {
  const _id = id || context.state.order.current?.id;
  const _messages = await api.getOrderMessages(_id)
  const messages = _messages.map(message => {
    if (context.state.delays.some(d => d.id === message.id)) {
      message.delayCount = context.state.delays.find(d => d.id === message.id).delay
      return message;
    } else {
      return message;
    }
  })
  context.commit('setOrderMessages', messages);
};

// TODO: handle situation with saving unauthenticated
export const createMessage = async ({ commit, getters }, _message) => {
  // SAVE MESSAGE ON API
  await api.createOrderMessage(getters.currentOrderId, ApiUtils.mapOrderMessageToApi(_message));
  // ADD MESSAGE TO MESSAGEPAGE LIST
  commit('ADD_ORDER_MESSAGE', _message);
  // UPDATE STATUS
  commit('ORDER_MESSAGE_CREATED');
};

export const createMessages = async (
  { commit, dispatch, getters },
  messages = getters.orderMessages
) => {
  if (messages.length) {
    const requestBody = {
      messages: messages.map(msg => ApiUtils.mapOrderMessageToApi(msg))
    }
    const responseMessages = await api.createOrderMessages(getters.currentOrderId, requestBody);
    commit('setOrderMessages', responseMessages);
  }
}

export const updateMessage = async (
  { commit, getters },
  _message
) => {
  const message = await api.updateOrderMessage(getters.currentOrderId, _message.id, ApiUtils.mapOrderMessageToApi(_message, true));
  commit('UPDATE_ORDER_MESSAGE', message);
};

export const deleteOrderMessage = async ({ commit, getters }, messageId) => {
  const orderId = getters.currentOrderId;
  await api.deleteOrderMessage(orderId, messageId);
  commit('DELETE_ORDER_MESSAGE', messageId);
}

export const addMessage = ({ commit }, message) => {
  commit('ADD_ORDER_MESSAGE', message);
}

export const editMessage = ({ commit }, message) => {
  commit('UPDATE_ORDER_MESSAGE', message);
}

export const deleteMessage = ({ commit }, messageId) => {
  commit('DELETE_ORDER_MESSAGE', messageId)
}

export const setOrderMessageTrigger = async ({ commit }) => {
  const triggers = await api.getOrderMessagesTrigger();
  commit('SET_ORDER_MESSAGE_TRIGGER', triggers)
}

// Message Builder
export const openMessageBuilder = (context, config) => {
  context.commit('setMessageBuilderConfig', config);
};

export const closeMessageBuilder = (context) => {
  context.commit('setMessageBuilderConfig', { open: false, edit: false, message: null })
};

// Order characters
export const loadOrderCharacters = async ({ commit, getters }, orderId = getters.currentOrderId) => {
  const characters = await api.getOrderCharacters(orderId);
  commit('SET_ORDER_CHARACTERS', characters);
};

export const loadDefaultCharacters = async ({ commit, getters }) => {
  const characters = await api.getOrderDefaultCharacters(getters.currentOrderId);
  commit('SET_DEFAULT_CHARACTERS', characters);
};

export const createCharacters = async (
  { commit, getters },
  data = {
    body: ApiUtils.mapOrderCharactersToApi(getters.selectedOrderCharacters),
    characters: getters.selectedOrderCharacters
  }
) => {
  const characters = await api.createOrderCharacters(getters.currentOrderId, data.body);
  const charactersWithRestoredIds = characters.map((ch, index) => {
    return ch.update({
      defaultId: data.characters[index].isDefault ? data.characters[index].id : null,
      imageFile: data.characters[index].imageFile,
      imagePreview: data.characters[index].imagePreview,
    })
  })

  commit('SET_ORDER_SELECTED_CHARACTERS', charactersWithRestoredIds.map(ch => {
    if (ch.defaultId) {
      return getters.defaultCharacters.find(char => char.id === ch.defaultId);
    } else {
      return ch;
    }
  }));
  commit('SET_ORDER_CHARACTERS', charactersWithRestoredIds.filter(ch => !ch.defaultId));

};

export const addCharacter = ({ commit }, character) => {
  commit('ADD_ORDER_CHARACTER', character);
}

export const updateCharacter = ({ commit }, character) => {
  commit('EDIT_ORDER_CHARACTER', character);
}

export const deleteCharacter = ({ commit }, characterId, orderId) => {
  commit('DELETE_CHARACTER', characterId);
};

export const selectOrderCharacter = ({ commit, getters }, character) => {
  if (!getters.selectedOrderCharacters.find(ch => ch.id === character.id)) {
    commit('SELECT_ORDER_CHARACTER', character);
  } else {
    commit('UNSELECT_ORDER_CHARACTER', character);
  }
}

export const saveCharacters = ({ commit }, characters) => {
  commit('SAVE_ORDER_CHARACTERS', characters.map((character, index) => character.update({ defaultId: characters[index].isDefault ? characters[index].id : null })));
  ;
}

// Order Attendees
export const loadAttendees = async (context) => {
  const orderId = context.state.order.current?.id;
  const attendees = await api.getOrderAttendees(orderId)
  context.commit('setOrderAttendees', attendees);
};

export const createOrderAttendees = async (
  { commit, dispatch, getters },
  attendees = ApiUtils.mapOrderAttendeesToApi(getters.orderAttendees)
) => {
  try {
    commit('SET_ORDER_ATTENDEES_ERRORS', {});
    await api.inviteAttendees(getters.currentOrderId, attendees)
    await dispatch('setAttendeesTouched', false);
    commit('ORDER_ATTENDEES_CREATED', true);

  } catch (e) {
    commit('SET_ERROR_MESSAGE', 'Incorrect attendees data. Please, check errors');
    commit('SET_ORDER_ATTENDEES_ERRORS', ApiUtils.extractBackendErrors(e));
    throw e;
  }
};

export const setAttendeesTouched = ({ commit }, status = true) => {
  commit('SET_ORDER_ATTENDEES_TOUCHED_STATUS', true);
}


export const deleteOrderAttendee = ({ commit }, id) => {
  commit('DELETE_ATTENDEE', id);
  commit('uploadCSV', false)
};

export const setOrderDetails = ({ commit, getters }, { details, valid, shouldUpdate = true }) => {
  commit('SET_ORDER_DETAILS', details);
  commit('SET_ORDER_DETAILS_VALID_STATUS', valid);

  if (!getters.orderDetailsTouched && !!getters.orderDetails && shouldUpdate) {
    commit('SET_ORDER_DETAILS_EDITED_STATUS', true);
  }
}

export const setOrderMenu = ({ commit }, menu) => {
  commit('SET_ORDER_MENU', menu)
}

export const inviteAttendeesCSV = async (context, file) => {
  const orderId = context.state.order.current?.id;
  const fd = new FormData();
  fd.append('import_file', file)
  const attendees = await api.inviteAttendeesCSV(orderId, fd)
  context.commit('setOrderAttendees', attendees);
  context.commit('uploadCSV', true);
};

export const setUploadCSVStatus = ({ commit }, status) => {
  commit('uploadCSV', status)
}

export const sendAttendeeInvitations = async (context, file) => {
  const orderId = context.state.order.current?.id;
  await api.sendAttendeeInvitation(orderId, file)
};

export const completeOrder = async ({ commit, state }, status = true) => {
  if (status) {
    await api.updateOrderStatus(state.order.uuid, 'FINALIZED')
  }
  commit('COMPLETE_ORDER', status);
}

export const payForOrder = async (context) => {
  const orderId = context.state.order.current?.id;
  const secret = await api.payForOrder(orderId);
  context.commit('setClientSecret', secret)
};

export const checkLocationAvailability = async (context, location) => {
  await api.checkLocationAvailability(location);
};

export const setRedirectAfterAuthUrl = ({ commit }, url) => {
  commit('setAuthRedirect', url);
}

export const shouldRestoreOrder = ({ commit }, status = true) => {
  commit('SHOULD_RESTORE_ORDER', status);
}

export const setAuthBehaviorType = ({ commit }, type) => {
  commit('SET_AUTH_BEHAVIOR_TYPE', type);
}

export const setOrderBehaviorType = ({ commit }, type) => {
  commit('SET_ORDER_BEHAVIOR_TYPE', type);
}

export const saveOrderAndExit = async ({ getters, dispatch }) => {
  switch (getters.lastStepFinished) {
    case 0: {
      if (getters.currentOrderId) dispatch('updateOrder');
      else dispatch('createOrder');
      return;
    }
    case 1: {
      // if (getters.currentStep === getters.lastStepFinished)
      if (getters.menuCreated) dispatch('updateOrderMenu');
      else dispatch('createOrderMenu');

      return;
    }
    case 2: {
      if (getters.orderMessages.length) {
        if (!getters.orderMessagesCreated) dispatch('createMessages');
      } else {
        if (getters.menuCreated) dispatch('updateOrderMenu');
        else dispatch('createOrderMenu');
      }
      return;
    }
    case 3: {
      dispatch('createCharacters');
      return;
    }
    case 4: {
      dispatch('createOrderAttendees');
      return;
    }
    case 5: {
      return;
    }
  }
}

// Todo: Join these two functions
export const saveCurrentStep = async ({ commit, dispatch, getters }) => {
  switch (getters.currentStep) {
    case 0: {
      if (getters.currentOrderId) await dispatch('updateOrder');
      else await dispatch('createOrder');
      break;
    }
    case 1: {
      if (getters.menuCreated) await dispatch('updateOrderMenu');
      else await dispatch('createOrderMenu');
      break;
    }
    case 2: {
      if (getters.orderMessages.length) {
        if (!getters.orderMessagesCreated) await dispatch('createMessages');
      } else {
        if (getters.menuCreated) await dispatch('updateOrderMenu');
        else await dispatch('createOrderMenu');
      }
      break;
    }
    case 3: {
      await dispatch('createCharacters');
      break;
    }
    case 4: {
      await dispatch('createOrderAttendees');
      break;
    }
    case 5: {
      break;
    }
  }
}

export const continueOrderAfterAuth = ({ commit }, status) => {
  commit('CONTINUE_ORDER_AFTER_AUTH', status);
}

export const validateLastFinishedStep = async ({ dispatch, getters }) => {
  switch (getters.lastStepFinished) {
    case 0: {
      await dispatch('validateOrderDetails');
      break;
    }
    case 1: {
      await dispatch('validateOrderMenu');
      break;
    }
    case 4: {
      await dispatch('validateOrderAttendees');
      break;
    }
    default:
      break;
  }
}

export const validateCurrentStep = async ({ commit, dispatch, getters }) => {
  switch (getters.currentStep) {
    case 0: {
      await dispatch('validateOrderDetails');
      break;
    }
    case 1: {
      await dispatch('validateOrderMenu');
      break;
    }
    case 4: {
      await dispatch('validateOrderAttendees');
      break;
    }
    default:
      break;
  }
}

export const validateOrderDetails = async ({ commit, getters }) => {
  try {
    commit('SET_ORDER_DETAILS_ERRORS', {});
    await api.validateOrderDetails(ApiUtils.mapOrderDetailsToApi(getters.orderDetails));
    commit('SET_ORDER_DETAILS_EDITED_STATUS', false);
  } catch (e) {
    commit('SET_ERROR_MESSAGE', 'Seems like you entered incorrect order details. Please, check errors');
    commit('SET_ORDER_DETAILS_ERRORS', ApiUtils.extractBackendErrors(e));
    throw e;
  }
}

export const validateOrderMenu = async ({ commit, getters }) => {
  try {
    commit('SET_ORDER_MENU_ERRORS', {});
    await api.validateOrderMenu(ApiUtils.mapOrderMenuToApi(getters.currentOrderId, getters.selectedMenu));
    commit('SET_ORDER_MENU_EDITED_STATUS', false);
  } catch (e) {
    commit('SET_ERROR_MESSAGE', 'Seems like the menu is not full. Please, check errors');
    commit('SET_ORDER_MENU_ERRORS', ApiUtils.extractBackendErrors(e));
    throw e;
  }
}

export const setMenuTouched = ({ commit }, status = true) => {
  commit('SET_ORDER_MENU_EDITED_STATUS', status);
}

export const validateOrderAttendees = async ({ commit, getters }) => {
  try {
    commit('SET_ORDER_ATTENDEES_ERRORS', {});
    await api.validateOrderAttendees(ApiUtils.mapOrderAttendeesToApi(getters.orderAttendees));
    commit('SET_ORDER_ATTENDEES_EDITED_STATUS', false);
  } catch (e) {
    commit('SET_ERROR_MESSAGE', 'Seems like you entered incorrect attendees data. Please, try again');
    commit('SET_ORDER_ATTENDEES_ERRORS', ApiUtils.extractBackendErrors(e));
    throw e;
  }
}

export const setCurrentStep = ({ commit }, step) => {
  commit('SET_CURRENT_STEP', step);
}

export const clearOrder = ({ commit }) => {
  commit('CLEAR_ORDER');
}

export const getPersonalDetails = async ({ commit }) => {
  const user = await api.getPersonalDetails();
  commit('SET_USER_INFO', user);
}

export const setAuthToken = ({ commit }, token) => {
  commit('SET_AUTH_TOKEN', token);
}

export const updatePersonalDetails = async ({ commit }, data) => {
  const user = await api.updatePersonalDetails(data);
  commit('SET_USER_INFO', user);
}

export const setSuccessMessage = ({ commit }, message, timeout = 3500) => {
  commit('SET_SUCCESS_MESSAGE', message);

  setTimeout(() => {
    commit('SET_SUCCESS_MESSAGE', null);
  }, timeout);
}

export const setErrorMessage = ({ commit }, message) => {
  commit('SET_ERROR_MESSAGE', message);

  setTimeout(() => {
    commit('SET_ERROR_MESSAGE', null);
  }, 3500);
}

// Attendee
export const loginAttendeeViaInvite = async (context, _data) => {
  try {
    const data = await api.loginAttendeeViaInvite(_data);
    context.commit('setAttendeeAuthData', { user: data.data, token: data.token });
    context.commit('SET_AUTH_DATA', data);
    context.commit('SET_AUTH_TOKEN', data.token);
    context.commit('setCurrentOrder', data.order);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const loadAttendeeOrderMenu = async ({ commit, getters }) => {
  const orderId = getters.currentOrderId;
  const order = await api.getAttendeeOrderMenu(orderId);
  commit('updateCurrentOrder', order);
  commit('SET_INITIAL_SELECTED_MENU', order.orderedMenu);
  return order;
};

export const loadAttendeeAvailableCharacters = async (context) => {
  try {
    const orderId = context.getters.currentSubOrder.uuid;
    const characters = await api.getAttendeeOrderAvailableCharacters(orderId);
    context.commit('setOrderCharacters', characters);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const loadAttendeeSubOrder = async ({ commit, getters }) => {
  const orderId = getters.currentOrderId
  const order = await api.getAttendeeSubOrder(orderId);
  if (order.status === 'FINISHED') {
    await router.push('/orders');
  }
  commit('setCurrentSubOrder', order);
  if (order.subCategories.length) {
    commit('UPDATE_INITIAL_SELECTED_MENU', getters.currentOrder.orderedMenu.map(ct => {
      const _ct = order.subCategories.find(sct =>
        sct.name === ct.name && ct.description === sct.description && ct.image === sct.image
      );

      if (_ct) {
        return {
          ...ct,
          items: ct.items.filter(it => _ct.items.find(_it => _it.name === it.name && _it.description === it.description && _it.image === it.image))
        }
      } else {
        return {
          ...ct,
          items: []
        }
      }
    }).filter(ct => ct));
  }
  return order;
}

export const loadAttendeeSubCharacter = async ({ commit, getters }) => {
  const orderId = getters.currentSubOrder.uuid;
  const character = await api.getSubOrderCharacter(orderId);
  commit('setAttendeeCharacter', character);
  return character;
}

export const createAttendeeSubOrder = async (context, _order) => {
  try {
    const order = await api.createAttendeeSubOrder(_order);
    context.commit('setCurrentSubOrder', order);
  } catch (error) {
    throw error;
  }
}

export const updateAttendeeSubOrder = async (context, _order) => {
  try {
    const id = context.getters.currentSubOrder.uuid;
    const order = await api.updateAttendeeSubOrder(_order, id);
    context.commit('updateCurrentSubOrder', order);
  } catch (error) {
    throw error;
  }
}

export const createAttendeeSubOrderMenu = async (context, _order) => {
  const order = await api.createAttendeeSubOrderMenu(_order);
  context.commit('updateCurrentSubOrder', order);
}

export const selectAttendeeCharacter = async (context, _character) => {
  try {
    const id = context.getters.currentSubOrder.uuid;
    const character = await api.selectAttendeeOrderCharacter(id, _character);
    context.commit('setAttendeeCharacter', character);
  } catch (error) {
    throw error;
  }
}

export const updateAttendeeCharacter = async (context, _character) => {
  try {
    const id = context.getters.currentSubOrder.uuid;
    const character = await api.updateAttendeeOrderCharacter(id, _character);
    context.commit('setAttendeeCharacter', character);
  } catch (error) {
    throw error;
  }
}

export const finishAttendeeSubOrder = async (context) => {
  try {
    const id = context.getters.currentSubOrder.uuid;
    await api.finishAttendeeSubOrder(id);
  } catch (error) {
    throw error;
  }
}